import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SCAMP_API } from "src/environments/environment";
import { AccountService } from "./account.service";

@Injectable({ providedIn: "root" })
export class LogService {
  constructor(
    private http: HttpClient,
    private account: AccountService,
  ) {}

  getAllByOSId(osid: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${SCAMP_API.accountApiV1}/logs-alteracoes-oss/${osid}`,
      { headers: this.account.composeHeaders() },
    );
  }

  post(data: any): Observable<any> {
    return this.http.post(
      `${SCAMP_API.accountApiV1}/logs-alteracoes-oss`,
      data,
      { headers: this.account.composeHeaders() },
    );
  }

  postAvaliacao(data: any): Observable<any> {
    return this.http.post(
      `${SCAMP_API.accountApiV1}/logs-avaliacoes-oss`,
      data,
      { headers: this.account.composeHeaders() },
    );
  }

  getLogAvaliacoesPelaOSId(osid: number): Observable<any> {
    return this.http.post(
      `${SCAMP_API.accountApiV1}/logs-avaliacoes-oss-por-osid/${osid}`,
      null,
      { headers: this.account.composeHeaders() },
    );
  }
}
